// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-qr-code[data-v-ed524bdc]{position:relative}.app-qr-code .qr-code[data-v-ed524bdc]{position:absolute;top:0;right:0;width:0;height:0;opacity:0;transition:all .3s ease-in-out;box-shadow:0 6px 16px -8px rgba(0,0,0,.08),0 9px 28px rgba(0,0,0,.05),0 12px 48px 16px rgba(0,0,0,.03)}.app-qr-code:hover .qr-code[data-v-ed524bdc]{width:180px;height:180px;z-index:10;opacity:1;position:absolute;right:0}", ""]);
// Exports
module.exports = exports;
